<template>
  <div>
    <GmapMap
      ref="gmap"
      :center="{ lat: 10, lng: 10 }"
      :zoom="5"
      :map-type-id="kmlMap"
      style="width: 100%; height: 500px"
      :options="{
        mapTypeControl: false,
      }"
    >
    </GmapMap>
    <template>
      <br />
      <div class="md-layout md-alignment-center-space-between">
        <md-button
          class="md-layout-item md-xsmall-size-40 md-size-40 gmaps-button md-simple"
          ><md-icon>description</md-icon
          ><a :href="kmlUrl">Download file</a></md-button
        >
        <md-button
          class="md-layout-item md-primary md-size-55 md-button md-round gmaps-button"
          @click="openGoogleMaps()"
          >Open in Google Maps</md-button
        >
      </div>
      <md-button
        v-if="kmlHistoryImagery && kmlHistoryImagery.length > 0"
        @click="showHistoricalImagery = true"
        >{{ showHistoricalImagery ? 'Hide' : 'Show' }} Historical Satellite
        Imagery</md-button
      >
      <public-gallery
        v-if="
          kmlHistoryImagery &&
          kmlHistoryImagery.length > 0 &&
          showHistoricalImagery
        "
        :items="kmlHistoryImagery"
      ></public-gallery>
    </template>
  </div>
</template>

<script>
import PublicGallery from '@/components/public/publicGallery.vue';
export default {
  components: {
    PublicGallery,
  },
  data() {
    return {
      attributes: [],
      showHistoricalImagery: false,
    };
  },
  props: {
    kmlUrl: {
      type: String,
      required: true,
    },
    kmlMap: {
      type: String,
      required: true,
      default: 'roadmap',
    },
    kmlHistoryImagery: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  mounted() {
    this.$refs.gmap.$mapPromise.then((map) => {
      let options = {
        map: map,
        url: `${this.kmlUrl}?dummy=${new Date().getTime()}`,
      };
      new google.maps.KmlLayer(options);
    });
  },
  methods: {
    openGoogleMaps() {
      // const gmapsLink = this.$refs.gmap.$mapObject.mapUrl;
      // const mapId = gmapsLink.split('ll=')[1];
      // const googleEarthLink = `https://www.google.com/maps/d/u/0/kml?mid=${mapId}&forcekml=1`
      // window.open(googleEarthLink, '_blank');
      window.open(this.$refs.gmap.$mapObject.mapUrl, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-attributes.scss';
.gmaps-button {
  text-transform: none;
}
</style>
